export default __webpack_public_path__ + "static/Spark_Plug-9a53cb1e7df91281fb39814f321aceaf.png";